<script>
  export let productoSeleccionado;
  export let productoLabel;
  export let azucarLabel;
  export let azucar;
</script>

<style>
  .display {
    width: 18em;
    margin: auto;
    padding: 10px;
    background: cornflowerblue;
    color: white;
    font-family: "Orbitron", sans-serif;
    border-radius: 5px;
    min-height: 4.6em;
    align-self: flex-end;
    letter-spacing: 2px;
    box-shadow: 0px 0px 25px 6px rgba(255, 255, 255, 0.5);
    border: 1px solid white;
  }
  .display em {
    float: right;
  }
  .display span {
    display: block;
    line-height: 1.7;
  }
</style>

<div class="display">
  {#if productoSeleccionado}
    <span>{productoLabel}</span>
    {#if azucarLabel}
      <span>
        {azucarLabel}
        <em>{azucar}/4</em>
      </span>
    {/if}
  {:else}
    <span>HAZ TU SELECCIÓN</span>
  {/if}
</div>
